var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-button',_vm._g({staticClass:"view-more-button content-trigger-hover"},_vm.$listeners),[_vm._v(" "+_vm._s(_vm.$t('common.viewMore'))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }